<template>
    <form @submit.stop.prevent="buscar" id="formulario-busca">
        <div class="form-row">
            <div class="col-md-4 col-sm-12">
                <label> Quero</label>
                <select v-model="formBusca.tipoPedido" class="form-control mb-4 mr-sm-2 mb-sm-0">
                    <option value="">Selecione</option>
                    <option v-for="tipoPedido in tiposPedido" :key="tipoPedido" :value="tipoPedido" v-text="tipoPedido"></option>
                </select>
            </div>
            <div class="col-md-4 col-xs-12" v-if="formBusca.tipoPedido === 'Consulta'">
                <label> Com</label>
                <v-select v-model="formBusca.especialidade"
                  @search="onSearchEspecialidade" :filterable="false"
                  :options="especialidades"
                  class="form-control mb-4 mr-sm-2 mb-sm-0">
                  <template slot="no-options">
                    Digite para encontrar a Especialidade...
                  </template>
                  <template slot="option" slot-scope="option">
                    <div class="d-center">
                      {{ option.nome }}
                    </div>
                  </template>
                  <template slot="selected-option" slot-scope="option">
                    <div class="selected d-center">
                      {{ option.nome }}
                    </div>
                  </template>
                </v-select>
            </div>
            <div class="col-md-4 col-xs-12" v-else-if="formBusca.tipoPedido === 'Exame'">
                <label>De</label>
                <v-select v-model="formBusca.exame"
                  @search="onSearchExame" :filterable="false"
                  :options="exames"
                  class="form-control mb-4 mr-sm-2 mb-sm-0">
                  <template slot="no-options">
                    Digite para encontrar o exame...
                  </template>
                  <template slot="option" slot-scope="option">
                    <div class="d-center">
                      {{ option.nomeExame }}
                    </div>
                  </template>
                  <template slot="selected-option" slot-scope="option">
                    <div class="selected d-center">
                      {{ option.nomeExame }}
                    </div>
                  </template>
                </v-select>
            </div>

            <div class="col">
                <label for="autocomplete"> Onde</label>
                <google-maps-autocomplete ></google-maps-autocomplete>
            </div>
            <div class="col-md-1">
                <label></label>
                 <button class="btn btn-primary btn-block mt-1"><i class="os-icon os-icon-search"></i></button>
            </div>
        </div>
    </form>
</template>
<script>

import _ from 'lodash'
import GoogleMapsAutocomplete from '@/components/shared/GoogleMapsAutocomplete'
import eventBus from '@/event-bus'

export default {
  components: {
    GoogleMapsAutocomplete
  },
  computed: {
    formBusca () {
      return this.$store.getters.formBusca
    },
    enderecoFormatado () {
      return this.$store.getters.enderecoFormatado
    },
    especialidade () {
      return this.$store.getters.formBusca.especialidade
    }
  },
  watch: {
    especialidade () {
      if (this.$route.name !== 'Home') {
        this.$store.dispatch('busca')
          .then(() => this.$toast.clear())
      }
    },
    'formBusca.tipoPedido' (newValue) {
      if (newValue === 'Exame') {
        eventBus.$emit('openModal', 'modalIrParaOrcamento')
      }
    }
  },
  data () {
    return {
      tiposPedido: ['Consulta', 'Exame'],
      especialidades: [],
      exames: [],
      cidades: []
    }
  },
  methods: {
    buscar () {
      this.$store.dispatch('busca')
        .then(() => {
          this.$router.push({ name: 'Busca' })
        })
    },
    onSearchEspecialidade (search, loading) {
      loading(true)
      this.searchEspecialidade(loading, search, this)
    },
    searchEspecialidade: _.debounce((loading, search, vm) => {
      vm.$store.dispatch('getEspecialidade', search).then(especialidades => {
        loading(false)
        vm.especialidades = especialidades
      })
    }, 350),
    onSearchExame (search, loading) {
      loading(true)
      this.searchExame(loading, search, this)
    },
    searchExame: _.debounce((loading, search, vm) => {
      vm.$store.dispatch('getExamesFormBusca', search).then(exames => {
        loading(false)
        vm.exames = exames
      })
    }, 350)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/busca/FormBusca.vue